import React from 'react';
import PropTypes from 'prop-types';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import AccountIdFilter from 'components/form/filters/AccountIdFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';

const AccountYieldsListFilters = (props) => {
    const filters = {
        basic: {
            account_id: {
                component: AccountIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

AccountYieldsListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default AccountYieldsListFilters;



// WEBPACK FOOTER //
// ./src/pages/account-yields/list/AccountYieldsListFilters.js